export class JiraTask {
  title: string;
  description: string;
  userEmail: string;
  sendConfirmationMail: boolean;
  cellNumber: string;
  summary: string;
  reporter: string;
  risks: string;
  assumptions: string;
  dependencies: string;
  priority: string;
  classification: string;
  remedyNumber: string;
  vfsDivision: string;
  businessArea: string;
  insuranceDept: string;
}
